<template src="./PostQualificationNotFound.html"></template>

<script>
export default {};
</script>

<style></style>
